require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./interview-andy-donaldson-rotarydisco.json") })
        }
      }, "path---interview-andy-donaldson-rotarydisco");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---interview-andy-donaldson-rotarydisco!./.cache/json/interview-andy-donaldson-rotarydisco.json
// module id = 653
// module chunks = 231608221292675